export const PAYROLLSTAGING_DIFFERENCE = "PAYROLLSTAGING_DIFFERENCE";
export const PAYROLLSTAGING_DIFFERENCE_SUCCESS =
  " PAYROLLSTAGING_DIFFERENCE_SUCCESS";
export const PAYROLLSTAGING_DIFFERENCE_FAIL = "PAYROLLSTAGING_DIFFERENCE_FAIL";
export const MOVE_TO_PAYROLL = "MOVE_TO_PAYROLL";
export const MOVE_TO_PAYROLL_SUCCESS = "MOVE_TO_PAYROLL_SUCCESS";
export const MOVE_TO_PAYROLL_FAIL = "MOVE_TO_PAYROLL_FAIL";
